// src/api/user-service/favoriteService.js
import client from '../client';

const TARGET_TYPE_MAP = {
  FARM: 'farm',
  EVENT: 'event',
  STAY: 'stay',
  PRODUCT: 'product',
};

function normalizeTargetType(targetType) {
  if (!targetType || typeof targetType !== 'string') return targetType;
  return TARGET_TYPE_MAP[targetType] || targetType;
}

/**
 * Add favorite (Like)
 * @param {Object} data - { targetType: 'FARM' | 'PRODUCT' | 'EVENT', targetId: number }
 * @returns {Promise<Object>} Created favorite data
 */
export const likeFavorite = async (data) => {
  const payload = { ...data, targetType: normalizeTargetType(data?.targetType) };
  return client.post('/users/me/favorites', payload).then(res => res.data);
};

/**
 * Remove favorite (Unlike)
 * @param {string} targetType - 'FARM' | 'PRODUCT' | 'EVENT'
 * @param {number} targetId - Target item ID
 * @returns {Promise<Object>} Deletion confirmation
 */
export const unlikeFavorite = async (targetType, targetId) => {
  return client.delete(`/users/me/favorites/${normalizeTargetType(targetType)}/${targetId}`).then(res => res.data);
};

/**
 * Check if item is favorited
 * @param {string} targetType - 'FARM' | 'PRODUCT' | 'EVENT'
 * @param {number} targetId - Target item ID
 * @returns {Promise<Object>} { favorited: boolean, favoriteId?: number }
 */
export const isFavorite = async (targetType, targetId) => {
  return client.get('/users/me/favorites/check', {
    params: { targetType: normalizeTargetType(targetType), targetId },
  }).then(res => res.data);
};

/**
 * Get my favorites list
 * @param {Object} query - { page?: number, limit?: number, targetType?: string, sort?: string, order?: 'ASC' | 'DESC' }
 * @returns {Promise<Object>} Paginated favorites list
 */
export const getMyFavorites = async (query = {}) => {
  return client.get('/users/me/favorites', { params: query }).then(res => res.data);
};
